export default {
  categories: 'Categories',
  segments: 'Segments',
  businesses: 'Companies',
  active: 'Active',
  inactive: 'Inactive',
  noBusinessesCreated: 'No businesses have been created',
  newBusiness: 'New Business',
  editBusiness: 'Edit Business',
  businessUrl: 'Business url',
  segment: 'Segment',
  insertExtraDataName: 'Insert extra data name',
  insertExtraDataValues: 'Insert extra data values',
  delete: 'Delete',
  addExtraData: 'Add extra data',
  businessSuccessfullyCreated: 'Business successfully created',
  businessSuccessfullyEdited: 'Business successfully edited',
  addNewBusiness: 'Add new business',
  uploadPhoto: 'Upload photo',
  doYouWantToDeleteThisContact: 'Do you want to delete this contact?',
  deleteContact: 'Delete contact',
  contactSuccessfullyDeleted: 'Contact successfully deleted',
  doYouWantToDeleteThisBusiness: 'Do you want to delete this business?',
  deleteBusiness: 'Delete business',
  businessSuccessfullyDeleted: 'Business successfully deleted',
  errorLoadingTheBusiness: 'There was an error loading the business',
  addContact: 'Add contact',
  nameOfTheBusiness: 'Name of the business',
  noCategories: 'Without categories',
  noLocation: 'Without location',
  noAddress: 'Without address',
  noSegment: 'Without segment',
  contactSuccessfullyAdded: 'Contact successfully added',
  contacts: 'Contacts',
  noRoles: 'Without roles',
  loadingBusinessContacts: 'Loading business contacts',
  noBusinessContacts: 'This business has no contacts'
}
